import {ICrudLocale} from "../../../i18n/interface";

export const PATIENT_MANAGEMENT_LOCALE_ES: ICrudLocale = {
  PATIENT_MANAGEMENT: {
    LABEL: {
      SINGULAR: "Paciente",
      PLURAL: "Pacientes"
    },
    FIELD: {
      COMMENTS: 'Comentarios',
      AGE: 'Edad',
      ASSOCIATE_PROFESSIONAL: 'Profesional asociado',
      PROFESSIONAL: 'Profesional',
      SESSION_COUNT: 'Cantidad de sesiones'
    },
    LIST: {
      TITLE: "Listado de Pacientes"
    }
  }
}
